module.exports = __webpack_public_path__ + "img/icon_white-big_bell.9768a16c.svg";